export const EXCLUDED_STRATEGIES = [
  '0xe12ed2925abbc984f07a106e06c4d74c977ba45f',
  '0x3b819ced007f4dea9962f5c14c15b3cd56eba74e',
  '0xcb3c757fc47bc42b2397e76b264414daf122def9',
  '0x4b0716567c785f7cb9c65d6ef9d072c8bc198b88',
  '0xdb90b583e487f07f779b7c0e2e4141ced2316b5c',
];
